export default "__VITE_ASSET__CTctTbPl__"